import { useTranslation } from '@testsigma/atoms';
import errorIcon from '@images/error.svg';

interface ConnectionFailureNoteProps {
  /**
   * Indicates whether the connection creation or update failed.
   */
  hasConnectionFailed: boolean;
}

/**
 * Displays an error message when Metadata/User connection creation or update fails.
 * @param {boolean} props.hasConnectionFailed Indicates whether the connection creation or update failed.
 * @returns null when props.hasConnectionFailed is false
 * @returns JSX when props.hasConnectionFailed is true
 */
export const ConnectionFailureNote = (props: ConnectionFailureNoteProps) => {
  const { t } = useTranslation();

  const { hasConnectionFailed } = props;

  // if connection has not failed: render null.
  if (!hasConnectionFailed) {
    return null;
  }

  // if connection is failed: render failure note ui.
  return (
    <div className='max-h-[calc(100%_-_120px)] overflow-auto'>
      <div className='px-8 mt-2'>
        <div className='rounded-lg border border-error-200 p-4'>
          <div className={'flex items-center'}>
            <img src={errorIcon} alt='' />
            <div className={'w-full ml-4'}>
              <div className={'text-sm leading-5 font-semibold'}>
                {t('connection-failed.info.label')}
              </div>
              <div
                className='text-unique-800 font-normal text-small leading-5 flex-wrap'
                dangerouslySetInnerHTML={{
                  __html: t('connection-failed-status.message'),
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
